import React from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';

import { IAppState } from 'src/store';
import './styles.scss';
import { Text } from '..';
import { isEmpty } from 'src/validations';

const ViewItem: React.FC<Props> = ({ label, value, variant = 'is-half' }) => {
  const isEmptyLine = isEmpty(label) && isEmpty(value);

  if (isEmptyLine) return <div className={cn('cmp-view-item__empty column', variant)} />;

  return (
    <div className={cn('cmp-view-item column', variant)}>
      <Text className="cmp-view-item__label">{label}</Text>
      <Text className="cmp-view-item__value">{value || '-'}</Text>
    </div>
  );
};

type Props = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps & {
    label?: string;
    value?: string | boolean | number | React.ReactElement;
    variant?: 'is-three-quarters' | 'is-two-thirds' | 'is-half' | 'is-one-third' | 'is-one-quarter' | 'is-full';
  };

const mapStateToProps = (state: IAppState) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ViewItem);
